import { render, staticRenderFns } from "./BaixinData.vue?vue&type=template&id=412fb273&scoped=true&"
import script from "./BaixinData.vue?vue&type=script&lang=js&"
export * from "./BaixinData.vue?vue&type=script&lang=js&"
import style0 from "./BaixinData.vue?vue&type=style&index=0&id=412fb273&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412fb273",
  null
  
)

export default component.exports